<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" cdkScrollable>
	<copo-panel-header [titleHeaderText]="'issue.qualityissues.drafts' | translate" (backButtonClick)="goBack()">
		</copo-panel-header>

	<div class="draft-list" copoVirtualScroller dataId="drafts" #scroller="copoVirtualScroller"
			[modelMapper]="modelMapper"
			(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
		<ng-container *ngIf="!scroller.loading && !isLoading; else loading">
			<div *ngFor="let draft of scroller.list" class="grid-column-one-full card-block">
				<div class="card-header">
					<div class="card-header-left">
						<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
						<span *ngIf="draft.reference" class="header-margin-right overflow-wrap">
								{{ draft.reference | uppercase }}</span>
						<span *ngIf="!draft.reference" class="copo-text-muted">&lt;<span
								translate>claim.no.reference</span>&gt;
							<mat-icon *ngIf="warnDraft(draft)" class="copo-claim-draft-alert" svgIcon="alert">
							</mat-icon>
						</span>
					</div>
				</div>
				<div class="card-content">
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>draft.creationdate</span>
						<span class="overflow-wrap">{{draft.creationDate | copoDate:'date'}}</span>
					</div>
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>draft.lastupdate</span>
						<span class="overflow-wrap">{{ draft.modifDate | copoDate:'date' }}</span>
					</div>
					<div class="card-container-column-draft">
						<span class="card-content-label-draft draft-title" translate>claim.created.by</span>
						<span class="overflow-wrap">{{ draft.creationBy }}</span>
					</div>
					<div class="card-container-column-draft card-column-around">
						<div class="card-container-link" *ngIf="draft.steeluserId!== undefined">
							<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
								(click)="eveEditDraft(draft.steeluserId)" [matTooltip]="'edit.draft' | translate">
								<mat-icon color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
								</mat-icon>
							</button>
							<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
								(click)="evtDeleteDraft(draft)" [matTooltip]="'quapp.action.delete' | translate">
								<mat-icon color="accent" svgIcon="garbage" class="image-draft-list-icon"></mat-icon>
							</button>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>